
<div class="row  mr-0">
  <div class="col-lg-12 text-right ">
    <button class="btn blue-btn btn-sm" data-bs-toggle="modal" data-bs-target="#modalSaveOrUpdate"
      *ngIf="global.OnboardType== 'CLIENT' || global.OnboardType== 'EMPLOYEE'">Add
      Contact</button>
  </div>
</div>


<div class="row ml-1 mr-2">
  <div class="table-responsive">
      <table class="table  table-hover "
          style="margin-top: 3px;">
          <tr style=" background-color:  #00786a">
              <th scope="col" style="color:white;background-color:  #00786a" class="pointer text-center">
                  Action</th>
              <th scope="col" style="color:white" class="pointer text-center">
              </th>
              <th scope="col" style="color:white" class="pointer text-center">
                  Contact Type</th>
              <th scope="col" style="color:white" class="pointer text-center">
                  Name</th>
              <th scope="col" style="color:white" class="pointer text-center">
                  Phone Number</th>
              <th scope="col" style="color:white" class="pointer text-center">
                  Email</th>
          </tr>
          <ng-container
              *ngFor="let contactInfo of ClientEmployeeContactData; let index=index">
              <tr>
                  <td class="text-center"  style="position: relative;background-color:  whitesmoke;">
                      <button class="btn btn-edit-table me-2 "
                          [disabled]="global.viewTabs || global.viewEmployeeTabs  || !fp?.contactupdate ||global.referralTab "
                          data-bs-toggle="modal" data-bs-target="#modalSaveOrUpdate"
                          (click)="selectedContactdetails(contactInfo)"><i
                              class="fa fa-edit"></i></button>
                      <button class="btn btn-delete-table" data-bs-toggle="modal"
                          [disabled]="global.viewTabs || global.viewEmployeeTabs|| !fp?.contactdelete || global.referralTab"
                          (click)="setDeleteId(contactInfo.id)"
                          data-bs-target="#modaldelete"><i
                              class="fa fa-trash"></i></button>
                  </td>
                  <td class="text-center">
                      <button class="btn btn-sm blue-btn"
                          style="border-radius: 28%;"
                          [disabled]="global.viewTabs || global.viewEmployeeTabs"
                          *ngIf="!contactInfo.showAdditionalDetails"
                          (click)="showOrHideAdditionalDetails(index)"><i
                              class="fa fa-plus"></i></button>
                      <button class="btn btn-sm btn-danger "
                          style="border-radius: 28%;"
                          [disabled]="global.viewTabs || global.viewEmployeeTabs"
                          *ngIf="contactInfo.showAdditionalDetails"
                          (click)="showOrHideAdditionalDetails(index)"><i
                              class="fa fa-minus"></i></button>
                  </td>
                  <td class="text-center">{{contactInfo.contactType_Lov}}</td>
                  <td class="text-center">{{contactInfo.name}}</td>
                  <td class="text-center">{{contactInfo.phoneNumber}}</td>
                  <td class="text-center">{{contactInfo.email}}</td>
              </tr>

              <ng-container *ngIf="contactInfo.showAdditionalDetails">
                  <tr style=" background-color:  #00786a">
                      <th scope="col" style="color:white"
                          class="pointer text-center"></th>
                      <th scope="col" style="color:white"
                          class="pointer text-center"></th>
                      <th scope="col" style="color:white"
                          class="pointer text-center">Address</th>
                      <th scope="col" style="color:white"
                          class="pointer text-center">Alternate Phone Number
                      </th>
                      <th scope="col" style="color:white"
                          class="pointer text-center"> Fax</th>
                      <th scope="col" style="color:white"
                          class="pointer text-center">Relationship to Client
                      </th>
                  </tr>
                  <tr>
                      <td class="text-center"></td>
                      <td class="text-center"></td>
                      <td class="text-center">{{contactInfo.street}}&nbsp;
                          {{contactInfo.city}}
                          {{contactInfo.state}}&nbsp; {{contactInfo.zipCode}}
                      </td>
                      <td class="text-center">
                          {{contactInfo.alternatePhoneNumber}}</td>
                      <td class="text-center"> {{contactInfo.fax}}</td>
                      <td class="text-center">{{contactInfo.relationship_Lov}}
                      </td>
                  </tr>
              </ng-container>

          </ng-container>
      </table>
      <div *ngIf="ClientEmployeeContactData.length == 0" class="text-center" style="color:red">
        <p>No data available</p>
      </div>
  </div>
</div>

<span id="openDelete" data-bs-toggle="modal" data-bs-target="#modaldelete"></span>
<div class="modal fade" id="modaldelete" data-bs-backdrop="static">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">
          <span>Delete </span>
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"> </span>
        </button>
      </div>
      <div class="modal-body">
        Are you sure you want to Delete?
      </div>
      <div class="modal-footer">
        <button type="button" class="btn blue-btn btn-sm" (click)="Delete()">Yes</button>
        <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">No</button>
      </div>
    </div>
  </div>
</div>
<span id="openContactModal" data-bs-target="#modalSaveOrUpdate" data-bs-toggle="modal"></span>
<div class="modal fade" id="modalSaveOrUpdate" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel"><span *ngIf="contactinfo.id=='00000000-0000-0000-0000-000000000000'"> Create
            ContactInfo</span>
          <span *ngIf="contactinfo.id!='00000000-0000-0000-0000-000000000000'">Update ContactInfo</span>
        </h5>
        
        <button type="button" class="btn-close" (click)="TypeContactValueChange()" aria-label="Close">
          <span aria-hidden="true"> </span>
        </button>
      </div>
      <div class="modal-body">
        <form [formGroup]="ContactInfoForm">
          <div class="row mt-2">
            <div class="col-lg-6">
              <div class="row">
                <div class="col-lg-5">
                  <label>Name<sup class="super-script">*</sup></label>
                </div>
                <div class="col-lg-7">
                  <input type="text" class="form-control" formControlName="Name" [(ngModel)]="contactinfo.name" placeholder="LastName, FirstName" (change)="isContactChange()">
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="row">
                <div class="col-lg-5">
                  <label>Contact Type<sup class="super-script">*</sup></label>
                </div>
                <div class="col-lg-7 d-inline-flex">
                  <select class="form-control" [(ngModel)]="contactinfo.contactTypeLid" formControlName="ContactTypes" (change)="isContactChange()">
                    <option [value]="ContactType.id" *ngFor="let ContactType of ContactTypeList">
                      {{ContactType.lovName}}</option>
                  </select>
                  <app-dropdown (EmitRefreshClick)="refreshToGetDropDownValues('CONTACTTYPE')"></app-dropdown>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-lg-6">
              <div class="row">
                <div class="col-lg-5">
                  <label>Relationship Type
                  </label>
                </div>
                <div class="col-lg-7 d-inline-flex">
                  <select class="form-control" [(ngModel)]="contactinfo.relationshipLid" (change)="isContactChange()"
                    formControlName="RelationshipType">
                    <option></option>
                    <option [value]="ConRel.id" *ngFor="let ConRel of ContactRelationshipList">
                      {{ConRel.lovName}}</option>
                  </select>
                  <app-dropdown (EmitRefreshClick)="refreshToGetDropDownValues('RELATIONSHIP')"></app-dropdown>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="row">
                <div class="col-lg-5">
                  <label>Phone Carrier Type
                  </label>
                </div>
                <div class="col-lg-7 d-inline-flex">
                  <select class="form-control" formControlName="phoneCarrier" [(ngModel)]="contactinfo.phoneCarrierLid" (change)="isContactChange()">
                    <option></option>
                    <option [value]="phoneCarrier.id" *ngFor="let phoneCarrier of phoneCarrierList">
                      {{phoneCarrier.lovName}}</option>
                  </select>
                  <app-dropdown (EmitRefreshClick)="refreshToGetDropDownValues('PHONECARRIER')"></app-dropdown>
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-2">

            <div class="col-lg-6">
              <div class="row">
                <div class="col-lg-5">
                  <label>Phone
                  </label>
                </div>
                <div class="col-lg-7">
                  <input class=" form-control" type="text" [(ngModel)]="contactinfo.phoneNumber"
                    formControlName="phoneNumber" (keypress)="keyPress($event)"
                    (ngModelChange)="DemographicPhoneFormat()" (change)="isContactChange()" minlength="14" maxlength="14">
                </div>


              </div>
            </div>
            <div class="col-lg-6">
              <div class="row">
                <div class="col-lg-5">
                  <label>Alternate Phone Number
                  </label>
                </div>
                <div class="col-lg-7">
                  <input class=" form-control" type="text" [(ngModel)]="contactinfo.alternatePhoneNumber"
                    formControlName="alternatePhoneNumber" (keypress)="keyPress($event)"
                    (ngModelChange)="DemographicPhoneFormat()"  (change)="isContactChange()" minlength="14" maxlength="14">
                </div>


              </div>
            </div>

          </div>
          <div class="row mt-2">
            <div class="col-lg-6">
              <div class="row">
                <div class="col-lg-5">
                  <label>Email
                  </label>
                </div>
                <div class="col-lg-7">
                  <input class="form-control" [(ngModel)]="contactinfo.email"
                  (ngModelChange)="checkValidateEmail()"   (change)="isContactChange()" formControlName="email"
                  (keypress)="global.preventforSpace($event)">
                  <span *ngIf="checkEmailValidation" style="color:red
                  ">Please enter valid email</span>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="row">
                <div class="col-lg-5">
                  <label>Fax
                  </label>
                </div>
                <div class="col-lg-7">
                  <input class=" form-control" type="text" [(ngModel)]="contactinfo.fax" formControlName="fax"
                    (keypress)="keyPress($event)" (ngModelChange)="DemographicPhoneFormat()" (change)="isContactChange()"  minlength="14"
                    maxlength="14">
                </div>
              </div>
            </div>

          </div>
          <div class="row mt-2">
            <div class="col-lg-6">
              <div class="row">
                <div class="col-lg-5">
                  <label>Street
                  </label>
                </div>
                <div class="col-lg-7">
                  <input class="form-control" [(ngModel)]="contactinfo.street" (change)="isContactChange()"  formControlName="street">
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="row">
                <div class="col-lg-5">
                  <label>City
                  </label>
                </div>
                <div class="col-lg-7">
                  <input class="form-control" [(ngModel)]="contactinfo.city" (change)="isContactChange()"  formControlName="city">
                </div>
              </div>
            </div>

          </div>
          <div class="row mt-2">
            <div class="col-lg-6">
              <div class="row">
                <div class="col-lg-5">
                  <label>State
                  </label>
                </div>
                <div class="col-lg-7">
                  <ng-select [items]="stateList" class="width25" [searchable]="true" (change)="isContactChange()"  [clearable]="true" bindLabel="name"
                    bindValue="abbreviation" [(ngModel)]="contactinfo.state" formControlName="state">
                  </ng-select>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="row">
                <div class="col-lg-5">
                  <label>Zip
                  </label>
                </div>
                <div class="col-lg-4">
                  <input class="form-control" minlength="5" maxlength="10" (keypress)="keyPress($event)"
                    formControlName="zip" [(ngModel)]="contactinfo.zipCode" (change)="isContactChange()" >
                </div>
                <div class="col-lg-3 mt-1">
                  <button class="btn blue-btn btn-sm " type="button" [disabled]="contactinfo.state ==null 
                                    || contactinfo.state =='' ||
                                    contactinfo.state ==undefined || contactinfo.city ==null || contactinfo.city =='' || 
                                    contactinfo.city ==undefined" (click)="getzipcode()">Get Zip</button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <!--  -->
      <div class="modal-footer">
        <button class="btn blue-btn btn-sm"  (click)="SaveOrUpdateContactInfo();"
          [disabled]="ContactInfoForm.invalid|| ContactInfoForm.valid &&disabledsavedbutton"><span
          *ngIf="contactinfo.id=='00000000-0000-0000-0000-000000000000'"> Save &
            Close</span><span *ngIf="contactinfo.id!='00000000-0000-0000-0000-000000000000'">Update & Close</span> </button>
        <button type="button" class="btn blue-btn btn-sm" (click)="TypeContactValueChange()">Close</button>
      </div>
    </div>
  </div>
</div>

<span id="typemodal" data-bs-toggle="modal" data-bs-target="#typeCloseModal"></span>
<div class="modal fade" id="typeCloseModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog create-update-zip " role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">Close</h5>
                <button type="button" class="btn-close" (click)="closetype()"> </button>
            </div>
            <div class="modal-body">
                You want to close without save?
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="backtoContact()" >Yes</button>
                <button type="button" class="btn blue-btn btn-sm" (click)="closetype()">No</button>
            </div>
        </div>
    </div>
</div>
